import { FilterBar } from '../../common/filters/FilterBar/FilterBar';
import { FilterChangeEvent, FilterValues } from '../../common/filters/types';
import { getProductFiltersConfig } from './config';

interface ProductFiltersProps {
    filterValues: FilterValues;
    corporationId: number;
    onFilterChange: (event: FilterChangeEvent) => void;
    onFilterClear: (filterId: string) => void;
    onClearAll: () => void;
}

const ProductFilters = ({
    filterValues,
    corporationId,
    onFilterChange,
    onFilterClear,
    onClearAll
}: ProductFiltersProps) => {
    const filters = getProductFiltersConfig(corporationId);

    return (
        <FilterBar
            filters={filters}
            onFilterChange={onFilterChange}
            onFilterClear={onFilterClear}
            onClearAll={onClearAll}
            filterValues={filterValues}
        />
    );
};

export default ProductFilters;